// The grid shows each photo through Cloudflare Image Transformations at tile size,
// not the full image. 18 full-size photos (9 MP originals, 2048px processed) were
// more than Safari 15 on the warehouse iMac could hold: it dropped decoded tiles and
// they sat white until redrawn (2026-10-19). A 600px JPEG is about 1/100th of that.
//
// Only on prism-commerce.com: transformations are switched on for that zone alone,
// so anywhere else (staging, local dev) the tile gets the full image as before.
// format=jpeg, never auto: Safari 15 on Catalina cannot decode WebP.
const THUMB_HOST = 'prism-commerce.com'
const THUMB_OPTIONS = 'width=600,fit=scale-down,quality=80,format=jpeg'

/** The URL a grid tile loads for `url`, or `url` itself where there is no resizing. */
export function photoThumbnailUrl(url, hostname = globalThis.location?.hostname) {
  if (!url || hostname !== THUMB_HOST) return url
  if (!/^https?:\/\//.test(url)) return url
  return `/cdn-cgi/image/${THUMB_OPTIONS}/${url}`
}
